import { render, staticRenderFns } from "./CP.vue?vue&type=template&id=65aa8676&"
import script from "./CP.vue?vue&type=script&lang=js&"
export * from "./CP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports